import {trackEvent} from 'analytics/Analytics';
import {LLM_CHAT_ANALYTICS_ACTIONS} from 'constants/analytics-products/LLMChatConstants';
import {markChatUseCaseUsed} from 'llm/chat-library/use-cases/chatUseCaseUsage';

/** Which entry point the use case was run from, so the run metric can be split by surface. */
export type ChatUseCaseRunSource = 'use_cases_tab' | 'progressive_disclosure' | 'onboarding';

/**
 * Record a use case the user actually ran.
 *
 * The analytics event and the stored history describe the same run, so every entry point records
 * both through here: no surface can report a run to one and not the other, which keeps the metric
 * and the "already run" badge describing the same set of runs.
 *
 * Call this only once the chat exists. An attempt that failed or was declined is not a run, and
 * counting it would both skew the metric and sort a prompt the user never saw as already tried.
 */
export default function recordChatUseCaseRun(
  chatUseCaseId: string,
  {categoryId, source}: {categoryId: string | undefined; source: ChatUseCaseRunSource}
): void {
  trackEvent(LLM_CHAT_ANALYTICS_ACTIONS.RAN_CHAT_USE_CASE, {chatUseCaseId, categoryId, source});
  markChatUseCaseUsed(chatUseCaseId);
}
